import cloneDeep from 'lodash/cloneDeep';
import { Auth } from 'aws-amplify';

const clientAuth = cloneDeep(Auth);

export default clientAuth;
